export default __webpack_public_path__ + "images/dom_active.png";